import { connect } from 'react-redux'
import React, { Component, PropTypes } from 'react'
import UpdatePasswordForm from 'client/features/session/components/UpdatePasswordForm.jsx'
import { UpdatePasswordRequest } from 'client/features/session/actions'
import FontAwesome from 'react-fontawesome'

class UpdatePassword extends Component {

    submit(payload, dispatch) {
        dispatch(UpdatePasswordRequest.post.action({ payload }))
    }

    render() {
        return (
            <div className='col-md-4 col-md-offset-4'>
                <div className='text-center'>
                    <h4 className='text-uppercase font-bold m-b-0'>Update your password</h4>
                </div>
                <div className='panel-body'>
                    {
                        this.props.session.updatePasswordProgress ?
                            <FontAwesome name='cog' spin />
                        :
                            <UpdatePasswordForm onSubmit={ this.submit }/>
                    }
                </div>
            </div>
        )
    }
}

UpdatePassword.contextTypes = {
    router: PropTypes.object.isRequired,
    store: PropTypes.object.isRequired,
    session: PropTypes.object
}

const mapStateToProps = (state) => {
    const { session } = state
    return {
        session
    }
}

export default connect(mapStateToProps)(UpdatePassword)


// WEBPACK FOOTER //
// ./src/client/features/session/containers/UpdatePassword.jsx